import { render, staticRenderFns } from "./EmailRecipientInput.vue?vue&type=template&id=146c06ef"
import script from "./EmailRecipientInput.vue?vue&type=script&lang=js"
export * from "./EmailRecipientInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports